module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"abweichende Lieferadresse wählen","new":"Neue Lieferadresse anlegen","no-result":"Kein Ergebnis","save":"Speichern","cancel":"Abbrechen"},"en":{"placeholder":"select different billing adress","new":"Create new billing adress","no-result":"No result","save":"Save","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
